import { connect } from 'react-redux';

import { getDealType, FDealType } from '../../../utils/deal_type';
import { getOfferType, FOfferType } from '../../../utils/offer_type';

import { IState } from '../../../store/index';

import { isNpsEnabled } from '../../../utils/experiments/NpsWidget';

import { TARGET_OFFER_TYPE } from './constants';

import { NpsWidget, INpsWidgetProps } from './NpsWidget';

const getHref = (dealType: FDealType, offerType: FOfferType): string | undefined => {
  if (!(offerType & TARGET_OFFER_TYPE)) {
    return undefined;
  }

  if (dealType & FDealType.RentLongterm) {
    return 'http://sgiz.mobi/s3/fa3b61cd4f75';
  }

  if (dealType & FDealType.Sale) {
    return 'http://sgiz.mobi/s3/778bb2460e36';
  }

  return undefined;
};

const mapStateToProps = (state: IState) => {
  const { offer, user } = state.offerData;

  return {
    href: getHref(
      getDealType(offer),
      getOfferType(offer),
    ),
    isAuthenticated: user && user.isAuthenticated,
    isEnabled: isNpsEnabled(state.experiments),
  };
};

export const NpsWidgetContainer = connect<INpsWidgetProps>(mapStateToProps)(NpsWidget);
